import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IPagination } from 'src/app/shared/models/pagination';
import { environment } from 'src/environments/environment';
import { IipObservation } from '../interfaces/Iip-observation';
import AllInvoices from '../interfaces/ip-all-invoices';
import FilterValues from '../interfaces/ip-filter-values';
import Invoice, { InvoiceForEdit } from '../interfaces/ip-invoice';
import { InvoicePaymentResponse } from '../interfaces/ip-invoice-payment-response';
import { PageResponse } from '../interfaces/ip-page-response';
import { PaymentProof } from '../interfaces/ip-payment-proof';
import { QueryParametersService } from './ip-query-parameter.service';

@Injectable({
  providedIn: 'root',
})
export class IpTableBillService {
  api = environment.api;

  constructor(
    private http: HttpClient,
    private queryParameterService: QueryParametersService
  ) {}

  getData(
    type: string,
    pagination: IPagination,
    sortFieldName: string = '',
    sortOrder: string = '',
    searchName: string = '',
    searchValue: string = '',
    filterValues: FilterValues,
    statusId: number,
    onlyReportedBills: boolean = false,
    ignoredTypeStatus?: number,
    supplierId?: number
  ): Observable<PageResponse<AllInvoices>> {
    const params = this.queryParameterService.buildQueryParameters(
      sortFieldName,
      sortOrder,
      pagination,
      searchName,
      searchValue,
      filterValues,
      statusId,
      ignoredTypeStatus,
      undefined,
      undefined,
      supplierId
    );

    // It may or may not have the extension
    let reportExtension = '';
    if (onlyReportedBills) {
      reportExtension = '/report';
    }
    return this.http.get<PageResponse<AllInvoices>>(
      `${this.api}/invopay/invoices${reportExtension}`,
      { params }
    );
  }

  getInvoicePaymentId(id: number): Observable<InvoicePaymentResponse> {
    return this.http.get<InvoicePaymentResponse>(
      `${this.api}/invopay/invoices/invoice-payment/${id}`
    );
  }

  deleteInvoice(id: number): Observable<Object> {
    return this.http.delete(`${this.api}/invopay/invoices/${id}`);
  }

  reportInvoice(id: number): Observable<Object> {
    return this.http.put(`${this.api}/invopay/invoices/report/${id}`, {});
  }

  payInvoice(request: PaymentProof): Observable<PaymentProof> {
    const formattedBody = this.toFormData(request);
    return this.http.post<PaymentProof>(
      `${this.api}/invopay/invoices/pay`,
      formattedBody
    );
  }

  toFormData(formValue: any) {
    const formData = new FormData();
    for (const key of Object.keys(formValue)) {
      const value = formValue[key];
      formData.append(key, value);
    }
    return formData;
  }

  updateInvoiceStatus(id: number, typeStatusId: number): Observable<Object> {
    return this.http.patch(`${this.api}/invopay/invoices/${id}`, {
      typeStatus: {
        id: typeStatusId,
      },
    });
  }

  getInvoiceById(id: number): Observable<Invoice> {
    return this.http.get<Invoice>(`${this.api}/invopay/invoices/${id}`);
  }
 
  getInvoiceByIdForEdit(id: number): Observable<InvoiceForEdit> {
    return this.http.get<InvoiceForEdit>(`${this.api}/invopay/invoices/for-edit/${id}`);
  }

  getPdf(url: string): Observable<string> {
    const encodedUrl = encodeURIComponent(url);
    return this.http.get<string>(
      `${this.api}/invopay/invoices/pdf?url=${encodedUrl}`
    );
  }

  getInvoiceObservations(id: number): Observable<IipObservation[]> {
    return this.http.get<IipObservation[]>(
      `${this.api}/invopay/observations/${id}`
    );
  }

  createInvoiceObservation(invoiceId: number, description: string) {
    return this.http.post<IipObservation>(
      `${this.api}/invopay/observations/invoice?invoiceId=${invoiceId}`,
      {
        description,
      }
    );
  }
}
